import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
export var DifficultyLevel = function (_a) {
    var difficultyLevel = _a.difficultyLevel, difficultyLevelMax = _a.difficultyLevelMax, _b = _a.className, className = _b === void 0 ? "" : _b;
    var difficulty = [];
    for (var i = 1; i <= difficultyLevelMax; i++) {
        var idIcon = i <= difficultyLevel ? IdIcon.RatingStarFillIcn : IdIcon.RatingStarEmptyIcon;
        difficulty.push(React.createElement("div", { key: "level_" + i },
            React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: idIcon })));
    }
    return React.createElement("div", { className: "flex v-s-margin " + className }, difficulty);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/difficultyLevel/DifficultyLevel.tsx
// module id = 612
// module chunks = 3